// extracted by mini-css-extract-plugin
module.exports = {"container":"userCeate_container__3dAib","userHeader":"userCeate_userHeader__2yXOY","heading":"userCeate_heading__2UEUn","icon":"userCeate_icon__lI190"};